import React, { Component, Fragment} from 'react';

import './Favorites.Module.scss';

import {cardData} from 'utilities/card';

import Card from 'components/UI/Card/Card';
import WorkshopCard from 'components/UI/WorkshopCard/WorkshopCard';
import Top from 'components/UI/Top/Top';
import FilterMenu from 'components/UI/FilterMenu/FilterMenu';
import Accordion from '../../components/UI/Accordion/Accordion';


/**
 * import components
 */

class Favorites extends Component {

    render() {

        return (
            <Fragment>
                
                <Top></Top>
                    <div styleName='pagewrapper'>
                    <FilterMenu></FilterMenu>
                    <div>
                        <div styleName='wrapper-grid'>
                            {
                                cardData.map((card, index) => 
                                <div>
                                    <Card 
                                    key={index}
                                    index={index} 
                                    card={card} 
                                    name={card.name} 
                                    slider1={card.slider1} slider2={card.slider2} slider3={card.slider3} 
                                    programlanguages={card.programlanguages} 
                                    icon1={card.icon1} icon2={card.icon2} icon3={card.icon3} 
                                    time={card.time}/>
                                    </div>
                                    )
                            }
                        </div>
                        
                        </div>
                    </div>
            </Fragment>
        );
    }
}

export default Favorites;